// src/components/ImageSection.js
import React from "react";
import "./ImageSection.css";
import buildingImage from "../assets/001.png";

const ImageSection2 = () => {
  return (
    <section className="image-section">
      <img src={buildingImage} alt="Building" className="building-image" />
    </section>
  );
};

export default ImageSection2;
